const styles = theme => ({
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingTitle: {
    maxWidth: '620px',
    textAlign: 'center',
  },
  loadingSubtitle: {
    color: '#838D98',
    maxWidth: '620px',
    textAlign: 'center',
  },
  progressWrapper: {
    width: '100%',
    maxWidth: '620px',
    padding: '0 16px',
  },
})

export default styles
